export const environment = {
  production: true,
  apiUrl: 'https://test-api.qober.nl'
};
